import { inDevelopment } from "../../config/keys";

export let baseURL = inDevelopment ? `http://localhost:5000` : `https://herbapp01.herokuapp.com`